import { render, staticRenderFns } from "./peopleInputForm.vue?vue&type=template&id=60c39c15&"
import script from "./peopleInputForm.vue?vue&type=script&lang=js&"
export * from "./peopleInputForm.vue?vue&type=script&lang=js&"
import style0 from "./peopleInputForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports